import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Scenarios from "@/pages/home/components/Scenarios";
import FeaturedMovies from "@/pages/home/components/FeaturedMovies";
import CategoryBrowser from "@/pages/home/components/CategoryBrowser";
import QualitySection from "@/pages/home/components/QualitySection";
import SpeedSection from "@/pages/home/components/SpeedSection";
import GuideSection from "@/pages/home/components/GuideSection";
import RankingSection from "@/pages/home/components/RankingSection";
import SeriesSection from "@/pages/home/components/SeriesSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <Scenarios />
        <FeaturedMovies />
        <CategoryBrowser />
        <QualitySection />
        <SpeedSection />
        <GuideSection />
        <RankingSection />
        <SeriesSection />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}